import { Fetcher } from 'swr'
import useSWRImmutable from 'swr/immutable'
import { client } from '~/api/client'
import { getFoldersFolderIdV1, Schemas } from '~/api/gen'
import { assertSuccess } from '~/lib/assertSuccess'

const getFoldersFolderIdV1Fetcher: Fetcher<
  Schemas.folder_detail,
  ['getFoldersFolderIdV1', number]
> = async ([_, folderId]) => {
  const result = await getFoldersFolderIdV1(client, {
    parameter: {
      folder_id: folderId,
    },
  })
  assertSuccess(result)

  return result.data.folder
}

export const useFolderDetail = (folderId: number) => {
  const res = useSWRImmutable<
    Schemas.folder_detail,
    Error,
    ['getFoldersFolderIdV1', number]
  >(['getFoldersFolderIdV1', folderId], getFoldersFolderIdV1Fetcher)
  return res.data
}
